import React from 'react';
import { TitleText } from 'components/Content/Atoms/TitleText';
import { SecondaryText } from 'components/Content/Atoms/SecondaryText';
import styles from './BlockHeading.module.scss';

interface Props {
  title?: string;
  secondaryText?: string;
  id?: string;
  /**
   * Renders in place of the plain-text secondary line. For blocks whose description is markdown
   * (Profile Cards), so they still get the shared title/description grouping and gap.
   */
  secondaryTextSlot?: React.ReactNode;
}

/**
 * A content block's heading: the title with its optional secondary text 8px beneath it (ENG-4399).
 *
 * Renders nothing when both are empty, and collapses to whichever one is set, so a block with no
 * secondary text keeps exactly the spacing it had before the field existed.
 */
export function BlockHeading(props: Props) {
  const { title, secondaryText, id, secondaryTextSlot } = props;
  const hasTitle = !!title?.trim();
  const hasSecondaryText = !!secondaryText?.trim() || !!secondaryTextSlot;

  if (!hasTitle && !hasSecondaryText) {
    return null;
  }

  return (
    <div className={styles.blockHeading}>
      {hasTitle && <TitleText text={title as string} id={id} type="title" flush />}
      {secondaryTextSlot ?? <SecondaryText text={secondaryText} flush />}
    </div>
  );
}
